import React from 'react';
import { useAlert, Alert, AlertType } from '../context/AlertContext';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

const AlertItem: React.FC<{ alert: Alert; onDismiss: (id: string) => void }> = ({ alert, onDismiss }) => {
    const config = {
        success: {
            icon: CheckCircle,
            borderColor: 'border-tudor-gold',
            bgColor: 'bg-green-900/90',
            textColor: 'text-tudor-gold',
        },
        error: {
            icon: AlertCircle,
            borderColor: 'border-red-600',
            bgColor: 'bg-red-900/90',
            textColor: 'text-red-200',
        },
        info: {
            icon: Info,
            borderColor: 'border-blue-500',
            bgColor: 'bg-blue-900/90',
            textColor: 'text-blue-200',
        },
    }[alert.type];

    const Icon = config.icon;

    return (
        <div
            className={`
        pointer-events-auto
        flex items-center gap-3 w-full max-w-sm
        p-4 rounded shadow-[0_0_15px_rgba(197,160,89,0.2)]
        border border-tudor-gold
        bg-black/95
        backdrop-blur-md
        transform transition-all duration-500 ease-out
        animate-fade-in-up
        hover:scale-[1.02]
      `}
            role="alert"
        >
            <Icon className={`w-5 h-5 ${config.textColor}`} />
            <div className={`flex-1 text-sm font-medium ${config.textColor}`}>
                {alert.message}
            </div>
            <button
                onClick={() => onDismiss(alert.id)}
                className="text-gray-500 hover:text-white transition-colors"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
};

export const AlertContainer: React.FC = () => {
    const { alerts, removeAlert } = useAlert();

    return (
        <div className="fixed top-20 left-0 right-0 md:top-4 md:right-24 md:left-auto md:w-auto z-[9999] flex flex-col gap-3 pointer-events-none p-4 items-center md:items-end">
            {alerts.map((alert) => (
                <AlertItem key={alert.id} alert={alert} onDismiss={removeAlert} />
            ))}
        </div>
    );
};
